import React, { useState, useEffect } from "react";
import hero from "../../Assets/hero-1.png";
import hero1 from "../../Assets/hero-2.png";
import hero2 from "../../Assets/hero-3.png";
import moon from "../../Assets/moon.png";
import about from "../../Assets/builders.jpg";
import { GiPlainSquare } from "react-icons/gi";
import safty from "../../Assets/Security.svg";
import ethics from "../../Assets/engineer_10344008.png";
import quality from "../../Assets/toolbox-green2.png";
import environment from "../../Assets/bulb.png";
import bg from '../../Assets/service-bg.jpg'
import part1 from '../../Assets/mpart-1.png';

const AboutUs = () => {
  const words = ["FASTER", "EASIER", "EFFICIENTLY"];
  const [index, setIndex] = useState(0);
  const coreValues = [
    {
      title: "Health & Safety",
      description:
        "Simple actions make a difference. It starts and ends with each employee striving to work safer every single day so they can return.",
      image: safty,
    },
    {
      title: "Professional Ethics",
      description:
        "Integrity is one of Graviton’s core values – we are committed to acting beyond reproach in all matters and to doing what is ethical.",
      image: ethics,
    },
    {
      title: "Experience & Quality",
      description:
        "We have a reputation for delivering quality products and services. That’s because our employees work together.",
      image: quality,
    },
    {
      title: "Environmental Protection",
      description:
        "Graviton is committed to conducting business in an environmentally responsible way by producing recycled materials.",
      image: environment,
    },
  ];
  useEffect(() => {
    const interval = setInterval(() => {
      setIndex((prevIndex) => (prevIndex + 1) % words.length);
    }, 2000); // Change text every 2 seconds

    return () => clearInterval(interval);
  }, [words.length]);

  return (
    <div className="max-w-screen-2xl mx-auto">
      {/* Hero Section */}
      <div className="bg-[#121315] h-auto   flex flex-col md:flex-row items-center justify-between   py-10 md:h-[311px]">
        <div className="  md:-mt-1 -mt-10">
          <img
            src={part1}
            alt="part"
            className="  w-44 md:h-[300px] h-24 object-contain"
          />
        </div>

        {/* Left Side - Text */}
        <div className="w-full md:w-1/2 text-center md:text-left ">
          <h1 className="text-white text-4xl md:text-5xl font-bold leading-tight">
            MANAGE YOUR <br /> PROJECT{" "}
            <span className="bg-[#068b07] text-transparent bg-clip-text transition-all duration-500">
              {words[index]}
            </span>
          </h1>
        </div>

        {/* Right Side - Images */}
        <div className="w-full md:w-1/2 flex justify-center md:justify-end  md:-m-0 -mb-10  md:mt-3 relative">
          <img
            src={moon}
            alt="moon"
            className="h-[100px] md:h-[130px]   absolute    md:-left-16  -left-0 object-contain"
          />

          <img
            src={hero}
            alt="Hero"
            className=" h-[220px]    md:ml-36 md:h-[300px] z-10 object-contain"
          />
          <img
            src={hero1}
            alt="Hero"
            className="h-[220px] md:h-[300px] z-10 -ml-12 md:ml-20  object-contain"
          />
          <img
            src={hero2}
            alt="Hero"
            className="h-[159px]  md:h-[230px]   md:pr-24  mt-[58px]  md:mt-[70px]  z-10    object-contain"
          />

          <div
            className="absolute bottom-0 -right-0 top-0 md:-top-4 w-0 h-0 border-gradient-to-r from-[#003F6B] to-[#FFFFFF] rounded-md
          border-t-[100px] md:border-t-[172px] border-t-transparent 
          border-r-[180px] md:border-r-[260px] border-r-white 
          border-b-[100px] md:border-b-[172px] border-b-transparent"
          ></div>
        </div>
      </div>

      {/* About Us Section */}
      <div className="py-16 px-6 md:px-20 bg-white ">
        <h2 className="text-4xl font-semibold text-[#068b07] mb-10 text-center uppercase tracking-wide">
          About Green Arcade
        </h2>

        <div className="flex flex-col md:flex-row items-center gap-12 h-[600px]">
          {/* Left - Text Content */}
          <div className="w-full md:w-1/2 space-y-6">
            <p className="text-gray-800 text-lg leading-relaxed">
              <span className="font-semibold text-[#068b07]">GREEN ARCADE</span>{" "}
              provides a unique mix of professionalism and a personal touch,
              rooted in strong family values. As a rapidly growing firm,{" "}
              <span className="font-semibold text-black">GREEN ARCADE</span>{" "}
              emphasizes work-life balance, creating an environment that
              motivates employees and earns the trust of customers for
              generations.
            </p>
            <p className="text-gray-800 text-lg leading-relaxed">
              Our foundation is built on the four pillars of trust –{" "}
              <span className="font-semibold text-black">
                quality, transparent legal procedures, timely project
                completion,
              </span>{" "}
              and{" "}
              <span className="font-semibold text-black">
                customer satisfaction.
              </span>
            </p>
            <p className="text-gray-800 text-lg leading-relaxed">
              We specialize in building{" "}
              <span className="font-semibold text-black">
                Individual Villas, Residential Apartments, Commercial Complexes,
              </span>{" "}
              and <span className="font-semibold text-black">Farmhouses.</span>{" "}
              Our commitment to superior quality sets us apart from the
              competition.
            </p>
          </div>

          {/* Right - Image */}
          <div className="w-full md:w-1/2 flex justify-center">
            <img
              src={about}
              alt="About Green Arcade"
              className="w-full max-w-lg"
            />
          </div>
        </div>
      </div>
      <div className="relative mt-8 md:-mt-20">
        {/* Background Image */}
        <img
          src={bg}
          alt="background"
          className="w-full h-[180vh] md:h-screen object-cover"
        />

        {/* Overlay Content */}
        <div className="absolute inset-0 flex items-center justify-center">
          <div className="max-w-screen-xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
            <div className="flex flex-col items-center space-y-6 md:space-y-10">
              {/* Graviton Title */}
              <div className="flex flex-wrap items-center justify-center space-x-2">
                <GiPlainSquare className="text-[#068b07] size-3 md:size-4" />
                <p className="text-gray-500 text-xs md:text-sm text-center">
                  GRAVITON SINCE 2010
                </p>
                <GiPlainSquare className="text-[#068b07] size-3 md:size-4" />
              </div>

              {/* Main Heading & Description */}
              <div className="text-center max-w-4xl px-4">
                <h1 className="text-xl md:text-4xl font-semibold text-black leading-tight md:leading-snug">
                  Building Your Visions. Creating Reality
                </h1>
                <p className="text-gray-800 text-xs md:text-sm mt-3 md:mt-4 leading-relaxed">
                  "We transform your vision into reality with unwavering
                  commitment, technical expertise, and superior craftsmanship.
                  Every project we undertake is built on precision, innovation,
                  and a dedication to delivering results that exceed
                  expectations. Your vision drives us, and we turn it into
                  structures that stand strong, reliable, and enduring."
                </p>
              </div>
              {/* Divider Line */}
              <span className="flex items-center w-full pt-4 justify-center mx-auto space-x-2">
                <GiPlainSquare className="text-[#068b07]" size={12} />
                <div className="w-4/6 h-[1px] bg-gray-300"></div>
                {/* Centered Line */}
                <GiPlainSquare className="text-[#068b07]" size={12} />
              </span>

              {/* Core Values Section */}

              <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6 md:gap-8 w-full">
                {coreValues.map((value, index) => (
                  <div
                    key={index}
                    className="flex flex-col items-center text-center"
                  >
                    <img
                      src={value.image}
                      alt={value.title}
                      className="h-14 w-14 md:h-16 md:w-16 object-contain mb-2 md:mb-4"
                    />
                    <h3 className="text-md md:text-lg text-black font-semibold">
                      {value.title}
                    </h3>
                    <p className="text-xs md:text-sm text-gray-600 mt-1">
                      {value.description}
                    </p>
                  </div>
                ))}
              </div>

              {/* CTA Button */}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutUs;
